import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { ICampaign, ICampaignLog } from "./types/_campaign";
const api = new APIClient();

const path = '/secured/campaign';
const campaignApi = {
  campaigns(params: any): Promise<AxiosResponse<ResponseData<ICampaign[]> & PaginationResponse, any>> {
    const url = `${path}/list`
    return api.get(url, params)
  },
  getCampaign(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}`;
    return api.get(url, { id, ...params })
  },
  getAssetCampaign(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/${id}/asset`;
    return api.get(url, { ...params })
  },
  postCampaign(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/create`;
    return api.post(url, dataForm)
  },
  putCampaign(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/update?id=${id}`;
    return api.post(url, dataForm)
  },
  deleteCampaign(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/${id}`;
    return api.delete(url, dataForm)
  },
  runCampaign(id: string | number): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/start`;
    return api.post(url, { id })
  },
  stopCampaign(id: string | number): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/stop`;
    return api.post(url, { id })
  },
  getCampaignLogs(params: any): Promise<AxiosResponse<ResponseData<ICampaignLog>, any>> {
    const url = `${path}/log`;
    return api.get(url, params)
  },
  updateBootingConfigCampaign(id: string | number, data: any): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/boosting`;
    return api.post(url, { id, ...data })
  },
  updateFundingCampaign(data: any): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/specificFund`;
    return api.post(url, data)
  },
  updateAllocationCampaign(data: any): Promise<AxiosResponse<ResponseData<ICampaign>, any>> {
    const url = `${path}/allocation`;
    return api.post(url, data)
  },
  getListExistedPool(params: any = {}): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/listExistedPool`;
    return api.get(url, params)
  },
  getListAvailableFeeTier(params: any = {}): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/listAvailableFeeTier`;
    return api.get(url, params)
  }
}
export default campaignApi
